import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderProfile"] */ "/app/src/shared/header-profile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header","HeaderLogoWithName"] */ "/app/src/shared/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/app/src/shared/sidebar.tsx");
